<section class="app__shell" [class.overflow-hidden]="isLoading()">
	<router-outlet />

	@if (isLoading()) {
		<azm-loading />
	}
</section>

<!-- thi is to trrest the CI/CD 5-->
